import React, { useCallback, useEffect, useState } from 'react';
import { FormLabel } from 'components/common';
import {
  Card,
  Tabs,
  Form,
  Typography,
  // Button,
  // message,
  Result,
  // Row,
} from 'antd';
// import { fetchSettings } from 'services/userProfileSetting';
import {
  fetchSettings,
  fetchChannelAccountSettings,
  saveChannelAccountSettings,
} from 'services/storeSetup';
// import { userProfiles } from 'utils/auth';
import { isJsonString } from 'utils';
import moment from 'moment';
import uiTypeRender from 'utils/uiTypeRender';

const { TabPane } = Tabs;
const { Title, Text } = Typography;

interface ChannelAccountSettingsProps {
  // channelNum: number;
  channelAccountNum: number;
  saveNow: boolean;
  editAble: boolean;
}

// eslint-disable-next-line
export default (props: ChannelAccountSettingsProps) => {
  const { channelAccountNum, saveNow, editAble } = props;
  const [activeTab, setActiveTab] = useState<string>();
  const [categoryVersion, setCategoryVersion] = useState(0);
  const [loading, setLoading] = useState(false);
  const [loading1, setLoading1] = useState(false);
  const [saveLoading, setSaveLoading] = useState(false);
  const [settings, setSettings] = useState<any[]>([]);
  const [userSetting, setUserSetting] = useState<{ [key: string]: any }>({});

  const [form] = Form.useForm();


  const getSettings = async () => {
    try {
      setLoading(true);
      const res = await fetchSettings(0); // not channelNum
      setLoading(false);
      if (res.isSuccess) {
        setSettings(res.data);
        if (!activeTab && res.data.length > 0) {
          setActiveTab(res.data[0].category);
        }
      }
    } catch (error) {
      setLoading(false);
    }
  };

  const getUserSettings = useCallback(async () => {
    try {
      setLoading1(true);
      const res = await fetchChannelAccountSettings(channelAccountNum);
      setLoading1(false);
      if (res.isSuccess) {
        const temp: { [key: string]: any } = {};
        res.data.map((item: any) => {
          temp[item.settingCode] = item.settingValue;
          return true;
        });
        setUserSetting({ ...temp, isReady: true });
      }
    } catch (error) {
      setLoading1(false);
    }
  },[channelAccountNum]);

  const isFieldVisible = (f: StringKAnyVPair) => {
    const fd: StringKAnyVPair = {
      CanadaPostReference1Text: 'CanadaPostReference1',
      CanadaPostReference2Text: 'CanadaPostReference2',
      CanadaPostReference3Text: 'CanadaPostReference3',
      PurolarorCAReference1Text: 'PurolarorCAReference1',
      PurolarorCAReference2Text: 'PurolarorCAReference2',
      PurolarorCAReference3Text: 'PurolarorCAReference3',
      PurolatorPONumberText: 'PurolatorPONumber',
      PurolatorReferenceText: 'PurolatorReference',
      PurolatorSONumberText: 'PurolatorSONumber',
    };
    const fvd = form.getFieldsValue();
    const fk = fd[f.settingCode];
    let ret = true;

    if (fk) {
      const v = fvd[fk] || userSetting[fk];
      //console.log('f', f, userSetting, fk, v);
      ret = v === '9';
    }

    return ret;
  };

  const onValuesChange = (changedValues: any, allValues: any) => {
    const fds = [
      'CanadaPostReference1',
      'CanadaPostReference2',
      'CanadaPostReference3',
      'PurolarorCAReference1',
      'PurolarorCAReference2',
      'PurolarorCAReference3',
      'PurolatorPONumber',
      'PurolatorReference',
      'PurolatorSONumber',
    ];
    const k = Object.keys(changedValues)[0];

    //console.log('c', changedValues);
    if (fds.indexOf(k) > -1) {
      //console.log('c', k, changedValues, allValues);
      setCategoryVersion(categoryVersion + 1);
    }
  };

  const saveSettings = useCallback(async () => {
    // const { masterAccountNum, profileNum } = userProfiles.profile;
    if(saveLoading) return;
    const params = await form.validateFields();
    const postParams = [];
    for (let i in params) {
      postParams.push({
        SettingCode: i,
        SettingValue: params[i],
        ChannelAccountNum: channelAccountNum,
        // MasterAccountNum: masterAccountNum,
        // ProfileNum: profileNum,
      });
    }
    try {
      setSaveLoading(true);
      const res = await saveChannelAccountSettings(
        channelAccountNum,
        postParams
      );
      setSaveLoading(false);
      if (res.isSuccess) {
        // message.success({ content: 'Saved Successfully' });
        getUserSettings();
      }
    } catch (error) {
      setSaveLoading(false);
    }
  },[channelAccountNum, getUserSettings, saveLoading, form]);

  const scopeKeySuffix = (cd: StringKAnyVPair) => {
    const categories = ["Purolator"];
    //console.log('s', activeTab, cd);
    return categories.indexOf(cd.category) > -1 ? `${categoryVersion}` : '';
  };

  useEffect(()=>{
    if(saveNow ){
      saveSettings()
    }
  },[saveSettings, saveNow])

  /* eslint-disable */
  useEffect(() => {
    getSettings();
    getUserSettings();
  }, []);
  /* eslint-enable */
  return (
    <>
      {/* <Row justify="end">
        <Button
          type="primary"
          loading={saveLoading}
          disabled={settings.length === 0}
          onClick={() => saveSettings()}
        >
          Save
        </Button>
      </Row> */}

      <Form
        form={form}
        labelCol={{
          style: { width: 300, display: 'flex', justifyContent: 'start' },
        }}
        onValuesChange={onValuesChange}
        wrapperCol={{
          style: { width: 'calc(100% - 300px)' },
        }}
      >
        <Card
          style={{ width: '100%', marginTop: 16, minHeight: 500 }}
          loading={loading || loading1}
          bodyStyle={{ padding: 8 }}
        >
          {settings.length > 0 ? (
            userSetting &&
            userSetting.isReady &&
            activeTab && (
              <Tabs
                activeKey={activeTab}
                size="middle"
                type="card"
                onChange={(value) => setActiveTab(value)}
              >
                {settings.map((i: any) => (
                  <TabPane tab={i.category} key={i.category}>
                    {i.scopes.map((m: any, idx2: number) => (
                      <Card
                        key={`${m.scope}${idx2}${scopeKeySuffix(i)}`}
                        size="small"
                        bordered={false}
                        style={{ marginBottom: 10 }}
                        title={<Title level={5}>{m.scope}</Title>}
                      >
                        {m.scopeItems.map((f: any, index: number) => {
                          return (!f.isVisibleByCustomer) ? null : (
                            <div key={`${f.settingCode}${index}`}>
                              <Form.Item
                                name={f.settingCode}
                                initialValue={
                                  f.settingDefUI.uiType === 3 ||
                                  f.settingDefUI.uiType === 11
                                    ? moment(userSetting[f.settingCode])
                                    : f.settingDefUI.uiType === 7
                                    ? isJsonString(userSetting[f.settingCode])
                                      ? JSON.parse(userSetting[f.settingCode])
                                      : []
                                    : f.settingDefUI.uiType === 12
                                    ? undefined
                                    : userSetting[f.settingCode]
                                }
                                hidden={!isFieldVisible(f)}
                                label={
                                  <FormLabel noColon>{f.settingName}</FormLabel>
                                }
                                rules={[
                                  {
                                    required:
                                      f.settingDefUI.uiType === 12 &&
                                      userSetting[f.settingCode]
                                        ? false
                                        //: true,
                                        : (isFieldVisible(f) || false),
                                    message: `${f.settingName} is required`,
                                  },
                                ]}
                              >
                                {uiTypeRender(
                                  f.settingDefUI,
                                  !f.canBeModifiedByCustomer || editAble
                                )}
                              </Form.Item>
                              {f.note && (
                                <Text
                                  style={{ marginLeft: 20 }}
                                  type="secondary"
                                >
                                  {f.note}
                                </Text>
                              )}
                            </div>
                          );
                        })}
                      </Card>
                    ))}
                  </TabPane>
                ))}
              </Tabs>
            )
          ) : (
            <Result
              status="error"
              title="Failed to extract configuration data."
              subTitle="Please contact the system administrator."
            ></Result>
          )}
        </Card>
      </Form>
    </>
  );
};
